declare global {
  interface Window {
    // eslint-disable-next-line
    dataLayer: any[];
  }
}

import React, { Suspense, lazy, useEffect, useState } from 'react';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';

import './styles/Loader.css';

import Navbar from './components/Navbar';
import ContactMenuCTA from './components/ContactMenuCTA';
const Home = lazy(() => import('./pages/Home'));
const Portfolio = lazy(() => import('./pages/Portfolio'));
const Contact = lazy(() => import('./pages/Contact'));
const About = lazy(() => import('./pages/About'));
const Experience = lazy(() => import('./pages/Experience'));
const Footer = lazy(() => import('./components/Footer'));
const ConsoleLogs = lazy(() => import('./components/ConsoleLogs'));

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

const Loader = () => (
  <div id="loader" style={{ background: '#000' }}>
    <span></span>
  </div>
);

const App: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (GA_MEASUREMENT_ID) {
      const loadAnalytics = () => {
        const script = document.createElement('script');
        script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
        script.async = true;
        document.head.appendChild(script);

        window.dataLayer = window.dataLayer || [];
        // eslint-disable-next-line
        const gtag = (...args: unknown[]) => {
          window.dataLayer.push(args);
        };
        gtag('js', new Date());
        gtag('config', GA_MEASUREMENT_ID);
      };
      if ('requestIdleCallback' in window) {
        (
          window as Window & { requestIdleCallback: (cb: () => void) => number }
        ).requestIdleCallback(loadAnalytics);
      } else {
        setTimeout(loadAnalytics, 2000);
      }
    }
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 1000); // Adjust duration based on your needs
    return () => clearTimeout(timeout);
  }, []);

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <Analytics />
      <SpeedInsights />
      <Navbar />
      <Suspense fallback={<Loader />}>
        <Home />
        <About />
        <Experience />
        <Portfolio />
        <Contact />
        <Footer />
        <ConsoleLogs />
      </Suspense>
      <ContactMenuCTA
        onScrollToSection={(sectionId) =>
          document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' })
        }
      />
    </>
  );
};

export default App;
